import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import styled from 'styled-components'

import MainMenu from './partials/MainMenu'

import Logo from '../assets/images/icon.png'

export default function MainLayout({ children }) {
	const [openMenu, setOpenMenu] = useState(false)
	const user = useSelector(state => state.auth.user)

	return (
		<Container>
			<TopBar className="no-print">
				<LogoContainer>
					<img src={Logo} alt="Logo Ingealimentos" width="30px" />
				</LogoContainer>
				<FontAwesomeIcon 
					icon={ openMenu ? faTimes : faBars}
					onClick={()=>setOpenMenu(!openMenu)}
					className="nav-toggle-icon"
				/>
				<div className="float-right mt-15 hide-sm">
					<p>{user.name}</p>
				</div>
			</TopBar>
			{ openMenu && (
				<MainMenu closeMenu={()=>setOpenMenu(false)} />
			)}
			<MainContent>
				{children}
			</MainContent>
			<Footer className='no-print'>
				<p>Desarrollado por{" "}
					<a href="//smart4.com.co" target="_blank" rel="noreferrer">
						Smart4 Solutions
					</a>
					{" | "}
					Versión {process.env.REACT_APP_VERSION}
				</p>
			</Footer>
		</Container>
	)
}

const Container = styled.div`
	width: 100%;
	min-height: 100vh;
	background-color: #f7f8f9;	
`

const TopBar = styled.div`
	width: 100%;
	padding: 5px 30px;
	background-color: #073a56;
	color: #fff;
	position: fixed;
	top: 0px;
	z-index: 10;
`

const MainContent = styled.div`
	padding: 25px 20px 20px;
	width: 100%;
	min-height: 90vh;
	position:relative;
	top: 52px;
`

const Footer = styled.div`
	padding: 30px 20px 20px;
	width: 100%;
	text-align: center;
	margin-top: 30px;
`

const LogoContainer = styled.div`
	background-color: #0a4c6f;
	padding: 10px;
	display: inline-block;
	margin-right: 10px;
	border-radius: 50px;
`